import type { Ref } from "vue";
import { ref } from "vue";

const maintenanceActive = ref(false);

export function setMaintenanceActive(active: boolean): void {
  maintenanceActive.value = active;
}

export const isInMaintenance: Readonly<Ref<boolean>> = maintenanceActive;
